"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _IncrementComponent = _interopRequireDefault(require("../../Increment/IncrementComponent"));
var _DiscountPill = _interopRequireDefault(require("../RecommendationAirtimePlans/Entel/DiscountPill"));
var _services = require("../../../services");
var _recommendationSelectors = require("../../../store/recommendation/recommendationSelectors");
var _recommendationActions = require("../../../store/recommendation/recommendationActions");
var _useConfig = _interopRequireDefault(require("../../../hooks/useConfig"));
var _coreSpacing = require("@vfuk/core-spacing");
var _useAppDispatch = require("../../../hooks/useAppDispatch");
var _useAppSelector = require("../../../hooks/useAppSelector");
var _useCustomer = require("../../../hooks/questionnaire/useCustomer");
var _questionnaireSelectors = require("../../../store/questionnaire/questionnaireSelectors");
var _useQuestionsMetadata = require("../../../hooks/questionnaire/useQuestionsMetadata");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Wrapper = _styledComponents.default.div`
  border: 1px solid #bebebe;
  padding: 24px;
  border-radius: 10px;
`;
const StyledGridColumnWrapper = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  display: grid;
  justify-items: left;
  ${props => props.isLarge && (0, _styledComponents.css)`
      justify-items: right;
    `}
`;
const MainTextWrapper = _styledComponents.default.div`
  display: flex;
  align-items: flex-end;
`;
const AdditionalPlan = _ref => {
  let {
    plan,
    planIndex
  } = _ref;
  const numberOfPlans = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectAdditionalPlans);
  const selections = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectQuestionsSelections);
  //it is important that the number of plans for calculating if we should display the additional plan section
  //is taken from the question selections and not the recommendation

  const {
    isCustomer
  } = (0, _useCustomer.useCustomer)();
  const metadata = (0, _useQuestionsMetadata.useQuestionsMetadata)({});
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const breakPoints = (0, _r10SourceLibrary.useBreakpoints)();
  const onChange = _ref2 => {
    let {
      type,
      value
    } = _ref2;
    dispatch((0, _recommendationActions.setAdditionalPlans)(value + (type === 'increment' ? 1 : -1)));
  };
  const maximumAdditionalPlans = (0, _useConfig.default)('maximumAdditionalPlans', 3);
  const AdditionalPlanParser = new _services.Parsers.AdditionalPlanParser(plan, numberOfPlans, maximumAdditionalPlans);
  const texts = AdditionalPlanParser.getTexts;
  const basicPlanIds = (0, _useConfig.default)('basicPlanIds', []);
  const isBasicPlan = basicPlanIds === null || basicPlanIds === void 0 ? void 0 : basicPlanIds.some(text => text.includes(plan === null || plan === void 0 ? void 0 : plan.productId.split('-')[0]));
  const showAdditionalPlanData = AdditionalPlanParser.showAdditionalPlanData({
    metadata,
    isCustomer
  });
  const shouldDisplayAdditionalPlanControls = (0, _react.useMemo)(() => {
    var _selections$numberOfP;
    return (selections === null || selections === void 0 ? void 0 : (_selections$numberOfP = selections.numberOfPlans) === null || _selections$numberOfP === void 0 ? void 0 : _selections$numberOfP[0]) === 0 && showAdditionalPlanData;
  }, [isCustomer, selections]);
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    columns: {
      sm: 1,
      md: shouldDisplayAdditionalPlanControls ? 3 : 2
    },
    verticalAlign: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: 3,
    justify: "left",
    dataAttributes: {
      'data-testid': `additional-plan-title-${planIndex}`
    },
    text: isBasicPlan ? _services.locale.localeString('Recommendation.additionalBasicPlanTitle') : _services.locale.localeString('Recommendation.additionalPlanTitle')
  })), /*#__PURE__*/_react.default.createElement(_coreSpacing.Spacing, {
    spacingLevel: {
      top: breakPoints.sm ? 6 : 0,
      bottom: breakPoints.sm ? 6 : 0
    }
  }, /*#__PURE__*/_react.default.createElement(StyledGridColumnWrapper, {
    isLarge: breakPoints.lgAndAbove
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_coreSpacing.Spacing, {
    spacingLevel: {
      bottom: breakPoints.sm ? 2 : 0
    }
  }, /*#__PURE__*/_react.default.createElement(_DiscountPill.default, {
    testId: `additional-plan-discount-${planIndex}`,
    text: texts.pillText
  }))), /*#__PURE__*/_react.default.createElement(MainTextWrapper, {
    "data-test-id": `additional-plan-price-after-discount-${planIndex}`
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    noMargin: true
  }, texts.mainText.large), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    noMargin: true,
    size: 1
  }, texts.mainText.normal)), /*#__PURE__*/_react.default.createElement(_coreSpacing.Spacing, {
    spacingLevel: {
      top: breakPoints.sm ? 2 : 0
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    dataAttributes: {
      'data-test-id': `additional-plan-price-${planIndex}`
    },
    size: 1
  }, texts.subText)))), shouldDisplayAdditionalPlanControls && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_IncrementComponent.default, {
    text: AdditionalPlanParser.incrementComponentText,
    value: numberOfPlans,
    onChange: onChange,
    buttons: AdditionalPlanParser.buttons,
    planIndex: planIndex
  }))));
};
var _default = AdditionalPlan;
exports.default = _default;